import { Component, Element, Host, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'anchor-form-group',
  styleUrl: 'form-group.scss',
  shadow: true,
})
export class FormGroup {
  @Element() host: HTMLElement;

  /**
   * Use this when the form group is placed on a non-white background
   * */
  @Prop() background: boolean = false;

  /**
   * This will trigger when a error message is added a slot
   * */
  @State() hasErrorSlotActive: boolean = false;

  componentWillLoad() {
    this.hasErrorSlotActive = !!this.host.querySelector("[slot='error-msg']");
  }

  render() {
    return (
      <Host>
        <slot name="label" />
        <div
          class={{
            'anchor-c-formgroup': true,
            'error': this.hasErrorSlotActive,
            'background': this.background,
          }}
        >
          <slot></slot>
        </div>
        <slot name="error-msg" />
      </Host>
    );
  }
}
